import MuiConfirmation from "components/MuiExtras/MuiConfirmation";
import { WithSnackbar, withSnackbar } from "components/SnackbarProvider/Snackbar";
import AppMessage from "components/Translations/AppMessage";
import { PublicationType } from "models/ApiEnums";
import { FeedItemDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import RequestErrorDialog from "components/CallServer/RequestErrorDialog";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: FeedItemDto;
    successMessage?: string;
    onRemovePublication: (publicationId: string, publicationType: PublicationType) => Promise<boolean>;
    onClose: () => void;
}

type Props = IProps & WithSnackbar & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

const Delete: React.FC<Props> = (props) => {

    const [lastError, setLastError] = React.useState(null);

    const {
        data: { publicationId, publicationType, publication },
        successMessage,
        onClose
    } = props;

    let dlgTitle = props.t("Common.Literals.RemoveText") + " ";
    let message = props.t("Views.Timeline.Dialogs.PublicationDelete.ConfirmationText", { title: publication.title });

    switch (publicationType) {
        case PublicationType.Course: dlgTitle += props.t("sys:PublicationType.Course"); break;
        case PublicationType.Post: dlgTitle += props.t("sys:PublicationType.Post"); break;
        case PublicationType.Question: dlgTitle += props.t("sys:PublicationType.Question"); break;
        case PublicationType.Answer: dlgTitle += props.t("sys:PublicationType.Answer"); message = props.t("Views.Timeline.Dialogs.PublicationDelete.ConfirmRemovalText"); break;
    }

    return (
        lastError == null
            ? (
                <MuiConfirmation
                    title={dlgTitle}
                    message={message}
                    onClose={
                        (result) => {

                            onClose();

                            if (result) {
                                props.onRemovePublication(publicationId, publicationType)
                                    .then((result) => {

                                        if (result)
                                            props.snackbar.showMessage(successMessage || props.t("Common.Feed.Messages.PublicationDeleteSuccess"), "success");
                                        else
                                            props.snackbar.showMessage(<AppMessage resource="OperationFailed" />, "error");

                                    })
                                    .catch((error) => {
                                        setLastError(error);
                                    });
                            }
                            
                        }
                    }
                />
            )
            : (
                <RequestErrorDialog
                    open={lastError != null}
                    error={lastError}
                    onClose={() => onClose()}
                />
            )
    );
};

export default withTranslation(['clientApp', 'sys'])(withSnackbar(Delete));